export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-4">
          随时随地看爆料
        </h2>
        <p className="text-background-50/80 mb-8 text-sm md:text-base max-w-lg mx-auto">
          下载每日大赛mrds移动客户端，mrds热门话题与每日爆料随身看，新瓜不错过
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="#about" className="inline-flex items-center gap-2 whitespace-nowrap bg-background-50 text-primary-600 px-6 py-3 rounded-full text-sm font-semibold hover:bg-background-100 transition-colors duration-200 cursor-pointer">
            <i className="ri-apple-fill text-lg w-5 h-5 flex items-center justify-center"></i>
            App Store 下载
          </a>
          <a href="#about" className="inline-flex items-center gap-2 whitespace-nowrap bg-background-50/20 text-background-50 border border-background-50/30 px-6 py-3 rounded-full text-sm font-semibold hover:bg-background-50/30 transition-colors duration-200 cursor-pointer">
            <i className="ri-android-fill text-lg w-5 h-5 flex items-center justify-center"></i>
            Android 下载
          </a>
        </div>
        <div className="mt-6 flex items-center justify-center gap-6 text-xs text-background-50/70">
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-300 w-4 h-4 flex items-center justify-center"></i>4.8 评分
          </span>
          <span>|</span>
          <span>50万+ 下载</span>
          <span>|</span>
          <span>每日更新</span>
        </div>
      </div>
    </section>
  );
}